module.exports = __webpack_public_path__ + "static/img/no-data.5a7c1977.png";